"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublisherNameAndIpiValid = void 0;
const validate_1 = require("@App/helpers/validate");
const isPublisherNameAndIpiValid = (publisherName, ipiNumber) => !(publisherName.length > 200 || !(0, validate_1.IPIValidator)(ipiNumber, true) || !publisherName || !ipiNumber);
exports.isPublisherNameAndIpiValid = isPublisherNameAndIpiValid;
